import React from "react";
import { useIntl } from "react-intl";

/*
  One error box for the page (not one per panel), also used compactly inside a Panel.
  Without `onRetry` it shows no button: a 403 means the user may not see this campaign, and a retry that fails the
  same way is worse than saying so.
*/
export const ErrorState = ({ title, message, onRetry }) => {
  const intl = useIntl();

  return (
    <div className="ff-error-box" role="alert">
      <h2>{title}</h2>
      <p>{message}</p>
      {typeof onRetry === "function" && (
        <button type="button" className="ff-btn-quiet" onClick={onRetry}>
          {intl.formatMessage({ id: "ff_dashboard.error.retry", defaultMessage: "Try again" })}
        </button>
      )}
    </div>
  );
};
